<template>
  <gg-modal :is-active="dialog" @close="close">
    <template v-slot:toolbar>Remove Addon Domain</template>
    <template v-slot:body>
      <v-progress-linear v-if="showLoading" indeterminate color="green" height="4"></v-progress-linear>
      <template v-else>
        <p>
          Are you sure you wish to <strong>permanently</strong> remove the addon domain “{{ addonDomain.domain }}”?
        </p>
        <v-checkbox v-if="ftpAccount"
                    color="green"
                    hide-details
                    label="Delete the associated FTP account"
                    v-model="deleteRelatedFtpAccount"></v-checkbox>
      </template>
    </template>
    <template v-slot:actions>
      <gg-btn secondary @click="close">Cancel</gg-btn>
      <gg-btn primary :loading="loading" @click="deleteAddon">Remove</gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import modalMixin from '@/mixins/modal'

export default {
  name: 'DeleteAddonDomainModal',
  mixins: [modalMixin],
  props: {
    addonDomain: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      loadingFtpAccounts: true,
      ftpAccount: null,
      deleteRelatedFtpAccount: false,
    }
  },
  mounted () {
    this.loadFtpAccount()
  },
  computed: {
    ...mapGetters({
      ftpAccountByDomainAndUser: 'ftp/ftpAccountByDomainAndUser'
    }),
    showLoading () {
      return !this.addonDomain || this.loadingFtpAccounts
    }
  },
  methods: {
    ...mapActions({
      removeHostingAddonDomain: 'hostingDomains/removeHostingAddonDomain',
      getFtpAccountsList: 'ftp/getFtpAccountsList',
      ftpExists: 'ftp/ftpExists',
      deleteFtpAccount: 'ftp/deleteFtpAccount',
      reportError: 'reportError',
      reportSuccess: 'reportSuccess',
    }),
    async deleteAddon () {
      try {
        const isValid = await this.$validator.validateAll()

        if (!isValid) {
          return
        }

        this.loading = true

        if (this.deleteRelatedFtpAccount) {
          // delete ftp account
          const [user, domain] = this.ftpAccount.serverlogin.toString().split('@')
          await this.deleteFtpAccount({ domain, user })
        }

        const { domain } = this.addonDomain
        const subdomain = this.addonDomain.domainkey
        const _username = this.$route.query.user
        const response = await this.removeHostingAddonDomain({ subdomain, domain, _username })
        if (response.error) {
          throw response.error
        }
        const messages = response.data.map(item => item.reason)

        messages.forEach(item => {
          this.reportSuccess(item)
        })

        this.$emit('addondomain-deleted')
        this.close()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },

    loadFtpAccount () {
      this.loadingFtpAccounts = true
      // cPanel indicates subdomain ftp account only when its username are same as subdomain's name
      const domain = this.addonDomain.domain
      const user = this.addonDomain.subdomain
      // search for related ftp account
      this.ftpExists({ domain, user }).then(
        () => {
          this.getFtpAccountsList()
            .then(() => {
              this.loadingFtpAccounts = false
              this.ftpAccount = this.ftpAccountByDomainAndUser({ domain, user })
            })
            .catch(() => {
              this.loadingFtpAccounts = false
              this.ftpAccount = null
            })
        },
        () => {
          this.loadingFtpAccounts = false
          this.ftpAccount = null
          // this endpoint throws error when account not found
        })
    },
  },
}
</script>
